import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import "../styles/PanelCarousel.css";

const PanelCarousel = ({ items }) => {
  const navigate = useNavigate(); 
  const containerRef = useRef(null);
  const itemCount = items.length+1;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [firstRun, setFirstRun] = useState(true);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    const delay = (currentIndex === 0 && firstRun===false) ? 10 : 8000;
    setFirstRun(false);

    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % itemCount);
    }, delay);

    return () => clearInterval(intervalRef.current);
  }, [currentIndex, itemCount]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      if (currentIndex > 0) {
        container.scrollTo({
          left: currentIndex * container.clientWidth,
          behavior: "smooth",
        });
      } else {
        container.scrollTo({
          left: currentIndex * container.clientWidth,
          behavior: "instant",
        });

      }
    }
  }, [currentIndex]);

  return (
    <div className="panel-carousel-container" ref={containerRef}>
      {[...items, items[0]].map((item, index) => (
        <div
          key={index}
          className={`panel-carousel-item`}
          onClick={() => {
            if (item.navigate) {
              navigate(item.navigate);
            }
          }}
        >
          <div className="panel-carousel-icon">
            <item.icon className="panel-carousel-image" />
            <div className="panel-carousel-label">{item.label}</div>
          </div>
          <div className="panel-carousel-description">{item.description}</div>
        </div>
      ))}
    </div>
  );
};

export default PanelCarousel;